module.exports = __webpack_public_path__ + "public/images/why-outschool-doodle-bottom-right.e4168b775db489d095cdb6559e91206e.webp";